import React from "react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface TranscriptModalProps {
  isOpen: boolean;
  onClose: () => void;
  transcript: string | null;
  title?: string;
  subtitle?: string;
  footerContent?: React.ReactNode;
}

export function TranscriptModal({
  isOpen,
  onClose,
  transcript,
  title = "Call Transcript",
  subtitle,
  footerContent,
}: TranscriptModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="z-[60] flex h-[774px] w-[600px] max-w-[600px] flex-col gap-0 rounded-[16px] p-0 font-body">
        <DialogHeader className="border-b p-4">
          <DialogTitle className="flex items-center gap-2 text-xl font-medium text-[#1f1e1d]">{title}</DialogTitle>
          <p className="mt-1 text-sm text-gray-600">{subtitle}</p>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {transcript ? (
            <p className="whitespace-pre-wrap text-sm leading-5 tracking-[-0.15px] text-[#1f1e1d]">
              {transcript}
            </p>
          ) : (
            <p className="text-sm italic text-[#58534c]">Transcript not available</p>
          )}
        </div>
        {footerContent && (
          <DialogFooter className="border-t p-4">{footerContent}</DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}
